import React from "react";
import GenericModal from "@ui-components/Modal/GenericModal";
import { GenericTable, GenericTableColumn } from "@ui-components/Table/GenericTable";

interface DeviceData {
  name: string;
  description: string;
  subId: string;
  data: {
    cloud: string;
    region: string;
    ha?: string | null;
    ha_ip?: string | null;
    cni?: Record<string, string>;
  };
}

interface DevicesModalProps {
  isOpen: boolean;
  onClose: () => void;
  instances: DeviceData[];
}

const columns: GenericTableColumn<DeviceData>[] = [
  { header: "Name", accessor: "name" },
  { header: "ID", accessor: "subId" },
  { header: "Cloud", renderCell: (row) => row.data.cloud },
  { header: "Region", renderCell: (row) => row.data.region },
  { header: "Activated", renderCell: (row) => row.data.region},
];

const DevicesModal: React.FC<DevicesModalProps> = ({ isOpen, onClose, instances }) => {
  return (
    <GenericModal isOpen={isOpen} onClose={onClose} title="Devices" size="lg">
      <GenericTable
        columns={columns}
        data={instances}
        initialRowsPerPage={5}
        rowsPerPageOptions={[5, 10, 20]}
        width="100%"
        tableClassName="bg-semantic-bg-primary"
      />
      {instances.length === 0 && (
        <div className="text-center text-gray-400 py-8">No devices found for this license.</div>
      )}
    </GenericModal>
  );
};

export default DevicesModal;
